import React from 'react';
import PropTypes from 'prop-types';
import { IconHotel, IconSuccess } from '@americanexpress/dls-icons';
import styles from './Steps.scss';
import { useDataFromOneCMS } from '../../fetchye/useDataFromOneCMS';

const ProgressComponent = ({ isOverlay }) => {
  const step1 = useDataFromOneCMS('howToSection.step1.heading');
  const step2 = useDataFromOneCMS('howToSection.step2.heading');

  return (
    <div
      className={`${styles.progressWrapper} pad-3-b flex flex-justify-center`}
    >
      <div
        className={`${styles.step} ${isOverlay && styles.borderWhite} flex position-relative flex-justify-center`}
      >
        <IconHotel
          aria-hidden="true"
          className="flex flex-align-items-center"
          color={isOverlay ? 'white' : 'brand'}
          size="md"
        />
        <span
          className={`${styles.text} ${styles.textLeft} ${isOverlay ? 'color-graphic-brand-logo-blue-box-text' : 'color-text-brand'} position-absolute text-nowrap`}
        >
          {step1}
        </span>
      </div>
      <span
        className={`${styles.line} ${isOverlay ? 'dls-white-bg' : 'dls-bright-blue-bg'} position-relative width-auto`}
      />
      <div
        className={`${styles.step} ${isOverlay && styles.borderWhite} flex position-relative flex-justify-center`}
      >
        <IconSuccess
          aria-hidden="true"
          className="flex flex-align-items-center"
          color={isOverlay ? 'white' : 'brand'}
          size="md"
        />
        <span
          className={`${styles.text} ${styles.textRight} ${isOverlay ? 'color-graphic-brand-logo-blue-box-text' : 'color-text-brand'} position-absolute text-nowrap`}
        >
          {step2}
        </span>
      </div>
    </div>
  );
};

ProgressComponent.propTypes = {
  isOverlay: PropTypes.bool.isRequired,
};

export default ProgressComponent;
